import React from 'react';
import type { FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { FormControlLabel, Switch } from '@mui/material';

import { StyledContainer } from '../styles';

import type { InputSwitchProps } from './types';

export default function InputSwitch<T extends FieldValues>({
  css,
  control,
  inputProps,
  label,
  name,
  defaultValue,
}: InputSwitchProps<T>) {
  return (
    <StyledContainer css={css}>
      <FormControlLabel
        label={label}
        control={
          <Controller
            control={control}
            defaultValue={defaultValue}
            name={name}
            render={({ field: { value, ...field } }) => (
              <Switch {...inputProps} {...field} checked={value} />
            )}
          />
        }
      />
    </StyledContainer>
  );
}
